import React, { useState } from 'react'; 

const ShopCartPage = ({ cartItems, onRemoveFromCart, onUpdateQuantity, onNavigate, clearCart }) => {
  const [showCheckout, setShowCheckout] = useState(false);
  const [customerData, setCustomerData] = useState({
    nombre: "",
    direccion: "",
    telefono: "",
    correo: ""
  });    const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
const shipping = subtotal > 0 ? 20000 : 0; // <-- ENVÍO FIJO AQUÍ
const total = subtotal + shipping;

const handleProceedToPayment = () => {
  if (cartItems.length === 0) return;
  setShowCheckout(true); // Solo muestra el formulario/modal
};
const enviarPedidoPorWhatsApp = () => {
  const productos = cartItems.map(item =>
    `• ${item.name} x${item.quantity} (${Number(item.price).toLocaleString("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 })})`
  ).join('%0A');

  const mensaje = `Hola 👋, he realizado un pedido desde la página *Atlantis Fish*:%0A%0A${productos}%0A%0A*Total a pagar:* ${Number(total).toLocaleString("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 })}%0A%0A*Datos del cliente*:%0A• Nombre: ${customerData.nombre}%0A• Dirección: ${customerData.direccion}%0A• Teléfono: ${customerData.telefono}${customerData.correo ? `%0A• Correo: ${customerData.correo}` : ''}%0A%0A¿Me puedes confirmar el costo de envío y el tiempo de entrega? ¡Gracias!`;

  const telefono = "573013346595";
  const url = `https://wa.me/${telefono}?text=${mensaje}`;
  window.open(url, "_blank");
  setShowCheckout(false);
  setTimeout(() => clearCart(), 2000);
};

  return (
    
    
    <div className="bg-background min-h-screen p-4 sm:p-8">
      {showCheckout && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-8 rounded-xl shadow-xl max-w-md w-full">
      <h3 className="text-xl font-bold mb-4 text-center">Completa tus datos</h3>
      <form
        onSubmit={e => {
          e.preventDefault();
          enviarPedidoPorWhatsApp();
        }}
        className="space-y-4"
      >
        <input
          className="w-full border p-2 rounded"
          type="text"
          placeholder="Nombre completo"
          required
          value={customerData.nombre}
          onChange={e => setCustomerData({ ...customerData, nombre: e.target.value })}
        />
        <input
          className="w-full border p-2 rounded"
          type="text"
          placeholder="Dirección"
          required
          value={customerData.direccion}
          onChange={e => setCustomerData({ ...customerData, direccion: e.target.value })}
        />
        <input
          className="w-full border p-2 rounded"
          type="tel"
          placeholder="Teléfono"
          required
          value={customerData.telefono}
          onChange={e => setCustomerData({ ...customerData, telefono: e.target.value })}
        />
        <input
          className="w-full border p-2 rounded"
          type="email"
          placeholder="Correo electrónico (opcional)"
          value={customerData.correo}
          onChange={e => setCustomerData({ ...customerData, correo: e.target.value })}
        />
        <div className="flex gap-2 mt-6">
          <button
            type="submit"
            className="flex-1 bg-green-600 hover:bg-green-700 text-white font-bold py-2 rounded transition-all"
          >
            Enviar pedido por WhatsApp
          </button>
          <button
            type="button"
            className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-2 rounded transition-all"
            onClick={() => setShowCheckout(false)}
          >
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>
)}

      <div className="container mx-auto max-w-6xl bg-card rounded-2xl shadow-xl p-4 sm:p-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-textPrimary mb-8 text-center">Tu Carrito de Compras</h1>

{cartItems.length === 0 ? (
  <div className="flex flex-col items-center justify-center bg-white/90 rounded-2xl shadow-xl py-14 px-4 max-w-xl mx-auto mt-10">
    <h2 className="text-2xl sm:text-3xl font-bold mb-4 text-center text-blue-900">Tu carrito está vacío</h2>
    <p className="text-gray-700 mb-6 text-lg sm:text-xl text-center">
      ¡Es hora de llenarlo con peces y productos increíbles!
    </p>
    <button
      onClick={() => onNavigate('shop')}
      className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg shadow-lg transition-all text-lg"
      style={{ letterSpacing: "0.5px" }}
    >
      <span role="img" aria-label="pez" className="mr-2">🐟</span>
      Explorar Productos
    </button>
  </div>
) : (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <div className="space-y-4 sm:space-y-6">
                {cartItems.map((item) => (
                  <div key={item.id} className="flex flex-col sm:flex-row items-center bg-background/70 p-3 sm:p-4 rounded-xl shadow-sm border border-waterBlue/30">
                    <img src={item.image} alt={item.name} className="w-20 h-20 sm:w-24 sm:h-24 object-cover rounded-lg mb-4 sm:mb-0 sm:mr-6 border border-waterBlue/40" />
                    <div className="flex-grow text-center sm:text-left w-full sm:w-auto">
                      <h3 className="font-semibold text-lg sm:text-xl text-textPrimary mb-1">{item.name}</h3>
                      <p className="text-textSecondary text-base sm:text-lg">${Number(item.price).toLocaleString("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 })}</p>
                      <div className="flex items-center justify-center sm:justify-start mt-2">
                        <button
                          onClick={() => onUpdateQuantity(item.id, item.quantity - 1)}
                          className="bg-gray-200 text-textPrimary px-2 sm:px-3 py-1 rounded-md hover:bg-gray-300 transition-colors"
                          disabled={item.quantity <= 1}
                        >
                          -
                        </button>
                        <span className="mx-2 sm:mx-3 text-base sm:text-lg font-medium">{item.quantity}</span>
                        <button
                          onClick={() => onUpdateQuantity(item.id, item.quantity + 1)}
                          className="bg-gray-200 text-textPrimary px-2 sm:px-3 py-1 rounded-md hover:bg-gray-300 transition-colors"
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <button
                      onClick={() => onRemoveFromCart(item.id)}
                      className="text-redError hover:text-red-700 transition-colors p-2 rounded-full hover:bg-red-100 mt-4 sm:mt-0"
                    >
                      <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                      </svg>
                    </button>
                  </div>
                ))}
              </div>
            </div>

<div className="lg:col-span-1 bg-white/95 p-6 rounded-xl shadow-lg border border-waterBlue/30">
  <h2 className="text-xl sm:text-2xl font-bold text-blue-900 mb-6">Resumen del Pedido</h2>
  <div className="space-y-3 text-base sm:text-lg text-gray-800">
    <div className="flex justify-between">
      <span>Subtotal:</span>
      <span>{Number(subtotal).toLocaleString("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 })}</span>
    </div>
    <div className="flex justify-between">
      <span>Envío:</span>
      <span>{Number(shipping).toLocaleString("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 })}</span>
    </div>
    <div className="flex justify-between font-bold text-lg sm:text-xl text-green-700 pt-4 border-t border-waterBlue/40 mt-4">
      <span>Total:</span>
      <span>{Number(total).toLocaleString("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 })}</span>
    </div>
  </div>
<button
  onClick={handleProceedToPayment}
  className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-lg font-bold text-lg shadow-lg transition-all mt-8"
>
  Proceder al Pago
</button>
  <button
    onClick={() => onNavigate('shop')}
    className="w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-bold text-md shadow-md transition-all"
  >
    Seguir Comprando
  </button>
<div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 mt-4 rounded-lg flex items-start gap-2 shadow-sm">
  <span role="img" aria-label="info" className="text-yellow-400 text-xl mt-0.5">ℹ️</span>
  <div className="text-xs text-gray-700 leading-snug">
    <span className="block mb-1">
      <b>El valor del envío es de <span className="text-green-700">$20.000</span> para Cúcuta, Patios y Atalaya.</b>
    </span>
    <b className="text-green-700 block mb-1">Para otras zonas consulta el valor por WhatsApp.</b>
    <span className="block">El costo de envío puede variar según el destino y la cantidad de productos. Te confirmaremos el valor exacto por WhatsApp al finalizar tu pedido.</span>
  </div>
</div>
</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShopCartPage;